import { getBackendUrl } from "@Utils";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./editor.css";
import { getCommentsData, saveCommentsData, deleteCommentsData } from "../../actions/bcfData";
import css from "./CommentsList.module.css";
import CommentsAdd from "./CommentsAdd";
import ButtonComponent from "../../cubeComponent/form/ButtonComponent";
import { BUTTON_TYPES } from "../../cubeComponent/constants/globalVariable";
import { DropDownButtonComponent } from "@syncfusion/ej2-react-splitbuttons";
import ToolTipComponent from "../../cubeComponent/html/tooltip";
import RichTextEditorComponent from "../../cubeComponent/form/RichTextEditorComponent";
import { convertDate } from "../../services/luxonHelper";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axiosWrapper from "../../services/axiosWrapper";
import UserNameTagComponent from "../../cubeComponent/html/UserNameTagComponent";
import _ from "lodash";
import IconComponent from "@CubeComponents/icons";

function CommentsList(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [showRichEditor, setShowRichEditor] = useState(false);
  const [editCommentsOperation, setEditCommentsOperation] = useState({});
  const [savedCommentsTitleOperation, setSavedCommentsTitleOperation] = useState({});
  const [savedCommentsSnapshotOperation, setSavedCommentsSnapshotOperation] = useState({});
  const [savedCommentsViewpointOperation, setSavedCommentsViewpointOperation] = useState({});
  const [offialCommentId, setOffialCommentId] = useState(null);
  const [bcfData] = useState("");
  const { userDetails, issues } = useSelector((state) => state);
  const [accordionState, setAccordionState] = useState({
    comments: true,
    elements: false,
  });

  useEffect(() => {
    fetchComments();
  }, []);

  useEffect(() => {
    if (props.offialCommentId) {
      setOffialCommentId(props.offialCommentId);
    }
  }, [props.offialCommentId]);

  const fetchComments = () => {
    dispatch(
      getCommentsData({
        issueId: props.issueId,
      }),
    );
  };
  const dropDownButtonItems = [
    { text: "Edit", id: "edit" },
    { text: "Delete", id: "delete" },
    { text: "Mark as Official", id: "official" },
  ];
  const dropDownButtonOfficialItems = [
    { text: "Edit", id: "edit" },
    { text: "Delete", id: "delete" },
  ];

  const insertImageSettings = { saveFormat: "Base64", display: "inline" };

  const handleSelectedOption = (args, cmtId, cmtCreatedBy) => {
    if (args.element.id == "edit") {
      handleEditClick(cmtId);
    } else if (args.element.id == "delete") {
      handleDeleteCommentClick(cmtId, cmtCreatedBy);
    } else if (args.element.id == "official") {
      handleOfficialCommentClick(cmtId, cmtCreatedBy);
    }
  };

  const userComentHeader = () => (
    <div style={{ display: "flex", alignItems: "center", columnGap: "10px" }}>
      <IconComponent name="prime_comments" className="h-5 w-5" />
      <span>{t("Comments")}</span>
    </div>
  );

  const elementsHeader = () => (
    <div style={{ display: "flex", alignItems: "center", columnGap: "10px" }}>
      <IconComponent name="akar-icons_shipping-box-01" className="w-5 h-5" />
      <span>{t("Elements")}</span>
    </div>
  );

  const getUserAvatar = (id) => {
    return <UserNameTagComponent showAvatarOnly id={id} size="LSM" isCircle />;
  };

  const handleEditClick = (commentId) => {
    setEditCommentsOperation({
      ...editCommentsOperation,
      [commentId]: issues[props.issueId].comments[commentId].title,
    });
    setSavedCommentsTitleOperation({
      ...savedCommentsTitleOperation,
      [commentId]: issues[props.issueId].comments[commentId].title,
    });
    if (issues[props.issueId].comments[commentId].snapshot) {
      setSavedCommentsSnapshotOperation({
        ...savedCommentsSnapshotOperation,
        [commentId]: issues[props.issueId].comments[commentId].snapshot,
      });
      setSavedCommentsViewpointOperation({
        ...savedCommentsViewpointOperation,
        [commentId]: issues[props.issueId].comments[commentId].viewpoint,
      });
    }
  };

  // const handleIssueViewPoint = async (commentId) => {
  //   let bcfData = await Communicator.BCFViewpoint.createViewpoint(hwv, "viewpoint.bcfv");
  //   delete bcfData._viewer;
  //   bcfData = cloneObject(bcfData);
  //   setBcfData(bcfData);

  //   const viewpoint = await cubeView.toJson(viewerImpl);
  //   setSavedCommentsViewpointOperation({
  //     ...savedCommentsViewpointOperation,
  //     [commentId]: viewpoint,
  //   });
  // };

  // const handleTakeSnapshot = async (commentId) => {
  //   const snapshot = await getCubeViewSnapshot();
  //   setSavedCommentsSnapshotOperation({
  //     ...savedCommentsSnapshotOperation,
  //     [commentId]: snapshot,
  //   });
  //   handleIssueViewPoint(commentId);
  // };

  const handleSaveCommentClick = (commentId) => {
    setSavedCommentsTitleOperation({
      ...savedCommentsTitleOperation,
      [commentId]: editCommentsOperation[commentId],
    });
    const savedData = {
      fileId: props?.fileVersionId,
      title: editCommentsOperation[commentId],
      issueId: props.issueId,
      snapshot:
        props.pdfViewer || props.issueIsStandalone
          ? null
          : savedCommentsSnapshotOperation[commentId].value
            ? savedCommentsSnapshotOperation[commentId].value
            : savedCommentsSnapshotOperation[commentId],
      viewpoint:
        props.pdfViewer || props.issueIsStandalone
          ? null
          : savedCommentsViewpointOperation[commentId].value
            ? JSON.stringify(savedCommentsViewpointOperation[commentId].value)
            : savedCommentsViewpointOperation[commentId],
      commentId,
      bcfData: props.pdfViewer || props.issueIsStandalone ? null : JSON.stringify(bcfData),
    };
    dispatch(saveCommentsData(savedData));

    handleCancelClick(commentId)();
  };
  const handleDeleteCommentClick = (commentId, createdBy) => {
    const Data = {
      commentId,
      createdBy,
    };
    dispatch(
      deleteCommentsData({
        ...Data,
        issueId: props.issueId,
      }),
    );
  };
  const handleOfficialCommentClick = async (commentId) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/issues/createOfficialComment`, {
      issueId: props.issueId,
      commentId,
    });
    if (response.data.status) {
      setOffialCommentId(commentId);
    }
  };

  const commentChangeHandler = (commentId) => (e) => {
    setEditCommentsOperation({
      ...editCommentsOperation,
      [commentId]: e.value,
    });
  };

  const saveButtonState = (commentId) => {
    const html = editCommentsOperation[commentId];
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || div.innerText || "";
    div.remove();
    if (text.trim() != "") {
      return false;
    }
    return true;
  };

  const handleCancelClick = (commentId) => () => {
    const editData = { ...editCommentsOperation };
    delete editData[commentId];
    setEditCommentsOperation(editData);
  };

  const commentHtml = (value) => {
    const comment = issues[props.issueId].comments[value];
    return (
      <div className={css.parentDivCmnt}>
        <div className={css.subDivCmnt}>
          <div className={css.profileImgDiv}>
            {getUserAvatar(comment.createdBy?._id, comment.createdBy.profilePic, {
              firstName: comment.createdBy.fullName.split(" ")[0],
              lastName: comment.createdBy.fullName.split(" ")[1],
            })}
          </div>
          <div className={css.commentsDetailsDiv}>
            <div className={css.commentsMetadata}>
              <span className={css.subCommentsMetadata}>
                <span className={css.commentsUserName}>
                  {comment.createdBy?.fullName && comment.createdBy.fullName}
                </span>
              </span>
              <div className={css.subCommentsMetadataTime}>
                {offialCommentId == comment._id && (
                  <div className="border rounded-full mt-1">
                    <span className="p-2 font-semibold">{t("Official")}</span>
                  </div>
                )}
                <ToolTipComponent
                  content={convertDate(Number(comment.createdDate), "dateForTooltip")}
                  position="bottom"
                >
                  <span className={css.commentDateTime}>{convertDate(Number(comment.createdDate), "dateForText")}</span>
                </ToolTipComponent>
                <DropDownButtonComponent
                  select={(args) => handleSelectedOption(args, comment._id, comment.createdBy._id)}
                  items={offialCommentId == comment._id ? dropDownButtonOfficialItems : dropDownButtonItems}
                  cssClass={`e-caret-hide ${css.hideDefaultPopoverIcon}`}
                >
                  <IconComponent name="HorizontalThreeDots" className="w-4 h-4" />
                </DropDownButtonComponent>
              </div>
            </div>
            <div className="mainComment">
              {comment.title && !Object.hasOwn(editCommentsOperation, comment._id) && (
                <RichTextEditorComponent
                  readonly
                  value={comment.title}
                  toolbarSettings={{ enable: false }}
                  showCharCount={false}
                />
              )}
              {comment.title && Object.hasOwn(editCommentsOperation, comment._id) && (
                <RichTextEditorComponent
                  change={commentChangeHandler(comment._id)}
                  toolbarSettings={{
                    items: ["Bold", "Italic", "Underline", "Alignments", "Outdent", "Indent"],
                  }}
                  id={css.oneditForRichText}
                  saveInterval={1}
                  value={savedCommentsTitleOperation[comment._id]}
                  showCharCount={false}
                  toolbarBgColor="#f0f5f9"
                  insertImageSettings={insertImageSettings}
                />
              )}
              {Object.hasOwn(editCommentsOperation, comment._id) && (
                <div className={css.addCommentButtons}>
                  <ButtonComponent
                    buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
                    onClick={() => handleSaveCommentClick(comment._id)}
                    disabled={saveButtonState(comment._id)}
                  >
                    {t("Save")}
                  </ButtonComponent>
                  <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={handleCancelClick(comment._id)}>
                    {t("Cancel")}
                  </ButtonComponent>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const userComentContent = () => (
    <div className={css.outterCmnt}>
      <div className={css.listCmnt}>
        {showRichEditor && (
          <CommentsAdd
            issueIsStandalone={props.issueIsStandalone}
            issueId={props.issueId}
            fileVersionId={props?.fileVersionId}
            handleAddComment={props.handleAddComment}
            issueIndex={props.issueIndex}
            handelShowAddComment={setShowRichEditor}
            pdfViewer={props.pdfViewer}
          />
        )}
        {!showRichEditor && (!props.showAddComment ? props.showAddComment : true) && (
          <div className={css.addCmnt}>
            {getUserAvatar(userDetails._id, userDetails.profilePic)}
            <input
              className={css.inputCmnt}
              onClick={() => {
                setShowRichEditor(true);
              }}
              placeholder={t("Write a comment")}
              type="text"
            />
            <div className={css.btngrp}>
              <IconComponent name="et_attachments" className="w-4 h-4" />
              <div className={css.postBtn}>{t("Post")}</div>
            </div>
          </div>
        )}
        {issues[props.issueId]?.comments &&
          Object.keys(issues[props.issueId].comments).map((value, index) => commentHtml(value, index))}
      </div>
    </div>
  );

  const elementsContent = () => {
    let uniqueNodeIds = new Set([]);
    if (_.get(props, "elements.length")) {
      uniqueNodeIds = [
        ...new Set(
          props.elements.map((item) => {
            return item.nodeId.split("_").splice(1).join("_");
          }),
        ),
      ];
    }

    return (
      <div className={css.elementList}>
        {Array.from(uniqueNodeIds).length
          ? Array.from(uniqueNodeIds).map((value, index) => (
              <div key={index} className={css.elements}>{`${value}`}</div>
            ))
          : "No elements associated"}
      </div>
    );
  };

  const handleAccordionState = (type) => (e, isExpanded) => {
    setAccordionState({
      ...accordionState,
      [type]: isExpanded,
    });
  };

  const comentAccordion = () => (
    <Accordion disableGutters expanded={accordionState.comments} onChange={handleAccordionState("comments")}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>{userComentHeader()}</AccordionSummary>
      <AccordionDetails>{userComentContent()}</AccordionDetails>
    </Accordion>
  );
  return (
    <div className={`${css.pageContent} commentListAccordian`}>
      {!props.pdfViewer && (
        <Accordion disableGutters expanded={accordionState.elements} onChange={handleAccordionState("elements")}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>{elementsHeader()}</AccordionSummary>
          <AccordionDetails>{elementsContent()}</AccordionDetails>
        </Accordion>
      )}
      {comentAccordion()}
    </div>
  );
}

export default CommentsList;
